/**
 * Filename / basename for repair attachment (string path/URL or File).
 */
export function repairAttachmentBasename(file) {
  if (!file) return "";
  if (typeof file === "string") {
    const path = file.split("?")[0].split("#")[0];
    return path.split("/").pop() || path;
  }
  return file.name || "";
}

/**
 * Image thumbnails + lightbox; plain text and other non-images open in a new tab.
 */
export function isRepairAttachmentImage(file) {
  const basename = repairAttachmentBasename(file);
  if (!basename || !basename.includes(".")) return false;
  const ext = basename.split(".").pop().toLowerCase();
  const textExtensions = [
    "txt",
    "text",
    "csv",
    "log",
    "md",
    "json",
    "xml"
  ];
  if (textExtensions.includes(ext)) return false;
  return ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(ext);
}


// Use the API for XHR downloads so CORS/auth do not depend on static-file headers.
export function repairAttachmentDownloadUrl(file, repairId) {
  if (!file || !repairId || /^(blob:|data:)/i.test(file)) return file;
  const name = repairAttachmentBasename(file);
  return "/repairs/" + encodeURIComponent(repairId) + "/attachment-download?name=" + encodeURIComponent(name);
}
